module.exports = __webpack_public_path__ + "img/sub-calendar.d22d4f05.svg";